import { normalizeUsPhoneDigits } from '@tnf-recruit/shared'

/**
 * Progressive mask for US phone inputs. Reformats from the digits on every
 * change, so typing and backspacing both land on "(555) 123-4567".
 */
export function formatUsPhone(value: string): string {
  const d = normalizeUsPhoneDigits(value).slice(0, 10)
  const area = d.slice(0, 3)
  const prefix = d.slice(3, 6)
  const line = d.slice(6, 10)

  if (d.length === 0) return ''
  if (d.length < 4) return `(${area}`
  if (d.length < 7) return `(${area}) ${prefix}`
  return `(${area}) ${prefix}-${line}`
}
